/** @jsx jsx */

import { ReactNode } from 'react';
import { jsx, css } from '@emotion/core';

type Props = {
  children: ReactNode;
  padding?: number;
};

const stylesRoot = ({ padding = 15 }) =>
  css`
    flex: 1;
    padding: ${padding}px;
    overflow-y: auto;
    overflow-x: hidden;
  `;

const DrawerBody = ({ children, padding }: Props) => (
  <div css={stylesRoot({ padding })}>{children}</div>
);

export default DrawerBody;
